import { useEffect } from 'react';
import { usePrefs } from './lib/prefs';
import { useRoute } from './lib/route';
import { boot, can, useApp } from './lib/session';
import { Company } from './pages/Company';
import { ChequesPage } from './pages/Cheques';
import { CustomersPage } from './pages/Customers';
import { Dashboard } from './pages/Dashboard';
import { DesignPage } from './pages/Design';
import { Help } from './pages/Help';
import { PeoplePage } from './pages/People';
import { RulesPage } from './pages/Rules';
import { ActivityLogPage } from './pages/ActivityLog';
import { PlanBuilderPage } from './pages/PlanBuilder';
import { ReceiptsPage } from './pages/Receipts';
import { StaffAccessPage } from './pages/StaffAccess';
import { AppVersionsPage, CloudReadingPage, IntegrityPage } from './pages/StaffControls';
import { TestersPage } from './pages/Testers';
import { pageAllowed } from './shell/nav';
import { Shell } from './shell/Shell';
import { PhoneOnly, SignIn } from './shell/SignIn';
import { SoonPage } from './shell/soon';
import { StaffOnly } from './shell/Staff';
import { useMenuDismiss } from './ui/kit';
import { Layers } from './ui/modal';
import { Toasts } from './ui/toast';

const PAGES: Record<string, () => JSX.Element | null> = { dashboard: Dashboard, help: Help, company: Company, rules: RulesPage, people: PeoplePage, customers: CustomersPage, receipts: ReceiptsPage, cheques: ChequesPage, design: DesignPage, testers: TestersPage, appversions: AppVersionsPage, integrity: IntegrityPage, cloudread: CloudReadingPage, activity: ActivityLogPage, staffaccess: StaffAccessPage, staffplans: PlanBuilderPage };

export function App() {
  usePrefs(); // re-render everything when the language or theme changes
  const st = useApp();
  const r = useRoute();
  useMenuDismiss();
  useEffect(() => { void boot(); }, []);
  let body: JSX.Element;
  if (st.auth.step === 'loading') body = <div className="boot" aria-busy="true" />;
  else if (!st.co && st.auth.step === 'none' && st.staff) body = <StaffOnly />;
  else if (!st.co || st.auth.step !== 'none') body = st.auth.step === 'none' ? <PhoneOnly kind="none" /> : <SignIn />;
  else if (!can('web')) body = <PhoneOnly kind="collector" />;
  else {
    const route = pageAllowed(r) ? r : 'dashboard';
    const Page = PAGES[route];
    body = <Shell>{Page ? <Page /> : <SoonPage r={route} />}</Shell>;
  }
  return <>{body}<Toasts /><Layers /></>;
}
